/**
 * Compra rápida de la tarjeta de producto, en móvil: en vez de estar
 * siempre visible (no hay hover que la revele en táctil), aparece con un
 * fade-in-up al entrar en pantalla y se retira si se sigue haciendo scroll
 * y la tarjeta sale de encuadre, para volver a aparecer si se vuelve atrás.
 *
 * En escritorio no hace nada: la visibilidad ya la controla el hover
 * (kaninor-product-card.css, @media (hover: hover)), así que este script se
 * sale si el dispositivo tiene hover de verdad.
 */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(hover: hover)').matches) return;

  const items = document.querySelectorAll('.kaninor-card__quick-add');
  if (!items.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('kaninor-card__quick-add--in-view', entry.isIntersecting);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.2 }
  );

  items.forEach((item) => observer.observe(item));

  // Tarjetas dentro de un <details> cerrado (el acordeón "Qué incluye"
  // del pack, kaninor-pinfo-block.liquid) no son intersecting mientras
  // está cerrado (display:none), así que el observer nunca las revela:
  // solo la que ya estuviera en pantalla al cargar la página quedaba
  // visible, el resto se quedaba con opacity:0 para siempre aunque el
  // usuario abriera el acordeón, porque abrir no mueve el scroll ni
  // dispara una nueva entrada al viewport. Al abrirse, se fuerza
  // directamente in-view en sus tarjetas y se deja de observarlas: si
  // siguieran observadas, el propio observer podía re-evaluarlas justo
  // durante la animación de apertura (grid-template-rows, ver
  // kaninor-pinfo-accordion.js) y decidir "no intersecting" en ese
  // instante concreto, quitando la clase que se acababa de forzar.
  document.querySelectorAll('details').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      details.querySelectorAll('.kaninor-card__quick-add').forEach((item) => {
        observer.unobserve(item);
        item.classList.add('kaninor-card__quick-add--in-view');
      });
    });
  });
})();
